/*
 * @Author: heyouqin@moyi365.com
 * @LastEditors: heyouqin@moyi365.com
 * @Date: 2024-01-29 16:05:58
 * @LastEditTime: 2024-02-29 16:47:33
 * @Descripttion: file content
 */
const homeworkAction = {
	UPDATE: 'update_state',
	CHECK_MODE: 'check_mode',
	SET_MODE: 'set_mode',
	INIT_MODE_DATA: 'init_mode_data',
	SET_MODE_DATA: 'set_mode_data',
	UPDATE_MODE_DATA: 'update_mode_data',
	SET_BOOK_ID: 'set_book_id',
	CHECK_UNIT_ID: 'check_unit_id',
	GET_UNIT_LIST: 'get_unit_list',
	GET_QUE_LIST: 'get_que_list',
	RESET_QUE_LIST: 'RESET_QUE_LIST',
	JOIN_OR_REMOVE_QUE: 'join_or_remove_que',
	CLEAR_MODE_SELECT_DATA: 'clear_mode_data',
	GET_PAPER_DETAIL: 'get_pager_detail',
	GET_EXAM_LIST: 'get_exam_list',
	GET_PHONETICS: 'get_phonetics',
	GET_DUBBING: 'get_dubbing',
	RESET_HOMEWORK_STORE: 'reset_homework_store',
	GET_QUES_LIST: 'get_ques_list',
	GET_AREA_TREE: 'get_area_tree',
	SET_AREA_TREE: 'set_area-tree'
}

export default homeworkAction
